import styled from '@emotion/styled';
import React from 'react';
import { ComponentColorMode, ComponentColors, getComponentColors } from '../../../foundations';
import { borderRadius } from '../../../foundations/borders/borderRadius';
import { ComponentSize } from '../../../foundations/modes/size';
import { spacing, spacingScaled } from '../../../foundations/spacing/spacing';

export interface IndicatorMarkProps {
  content: string | React.ReactNode;
  indicatorTheme?: ComponentColorMode;
  size?: ComponentSize;
  subjacent?: boolean;
  dashedBorder?: boolean;
}

// WIP component while we are researching the use cases and discussing design. Will just be used for answer cards atm.

export const IndicatorMark: React.FC<IndicatorMarkProps> = ({
  content,
  indicatorTheme = 'neutral',
  size = 'small',
  subjacent = false,
  dashedBorder = false,
}) => {
  const colors = getComponentColors(indicatorTheme);
  return (
    <StyledIndicatorMark colors={colors} size={size} subjacent={subjacent} dashedBorder={dashedBorder}>
      {content}
    </StyledIndicatorMark>
  );
};

type StyledIndicatorMarkProps = Pick<IndicatorMarkProps, 'size' | 'subjacent' | 'dashedBorder'> & {
  colors: ComponentColors;
};

const StyledIndicatorMark = styled.div<StyledIndicatorMarkProps>`
  color: ${({ subjacent, colors }) => (subjacent ? colors.onSubjacent : colors.on)};
  background-color: ${({ subjacent, colors }) => (subjacent ? colors.fillSubjacent : colors.fill)};
  border: ${({ subjacent, dashedBorder, size, colors }) =>
    `${spacingScaled(spacing.size2, size)} ${dashedBorder ? 'dashed' : 'solid'} ${
      subjacent ? colors.strokeSubjacent : colors.stroke
    }`};
  border-radius: ${borderRadius.roundedFull};
  padding: ${({ size }) => spacingScaled(spacing.size2, size)};
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ size }) => spacingScaled(spacing.size24, size)};
  height: ${({ size }) => spacingScaled(spacing.size24, size)};
  flex-shrink: 0;
`;
